<template>
  <b-sidebar id="sidebar-left" header-class="bg-primary" shadow backdrop no-close-on-backdrop no-close-on-esc style="z-index:1039;">
    <template #header="{ hide }">
      <small class="text-white">Despre</small>
      <b-button-close @click="hide" class="text-white" />
    </template>
    <template #footer="{ hide }">
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <small class="mr-auto ml-auto" @click="clicks++">1.0.0</small>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
export default {
  name: 'SidebarLeft',
  mixins: [],
  props: {},
  components: {},
  data () {
    return {
      clicks: 0
    }
  },
  methods: {
    feedbackSend () {
      alert('Multu')
    }
  },
  computed: {
  },
  watch: {
    clicks (newVal) {
      if (newVal === 5) {
        this.feedbackSend()
        this.clicks = 0
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
